<template>
  <div>
    <div
      class="pa-3"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <v-btn
        :to="`/weserve_admin_login/-/maindinein/storemanage`"
        icon
        color="#e9e9e9"
        ><v-icon>arrow_back</v-icon></v-btn
      >
      <div class="heading__1">
        Store special close :
        <span style="color: grey"> {{ $route.params.store_name }}</span>
      </div>
      <v-btn fab color="primary" @click="formStoreSpecialDialog = true"
        ><v-icon color="black">add</v-icon></v-btn
      >
    </div>
    <v-card class="elevation-0" style="border: 1px solid black">
      <v-data-table
        :headers="headers"
        :loading="isLoadingData"
        :items="storeCloseData.store_close"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>

          <td class="text-xs-center">
            {{ props.item.dateTime }}
          </td>
          <td class="text-xs-center">
            {{ props.item.startTime.substring(0, 5) }} -
            {{ props.item.endTime.substring(0, 5) }}
          </td>

          <td class="text-xs-center">
            {{ props.item.description || "-" }}
          </td>

          <td class="text-xs-center">
            <v-btn
              icon
              class="view-detail-btn"
              color="primary"
              @click="toEditStoreSpecial(props.item, props.index)"
            >
              <v-icon style="font-size: 18px; color: black">edit</v-icon>
            </v-btn>

            <v-btn
              icon
              class="view-detail-btn"
              color="error"
              @click="toDeleteStoreSpecial(props.item, props.index)"
              :loading="isDeleteSpecial.includes(props.item.id)"
            >
              <v-icon style="font-size: 18px; color: white">delete</v-icon>
            </v-btn>
          </td>
        </template>

        <template slot="no-data">
          <div v-if="isLoadingData == true" class="text-xs-center">
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            {{ isLoadingData == true ? "Loading data ..." : isLoadingData }}
          </div>
          <div v-else class="text-xs-center">No data available</div>
        </template>
      </v-data-table>
    </v-card>
    <FormSpecialDinein
      :dialog="formStoreSpecialDialog"
      :editedIndex="selected_index"
      @onClose="
        formStoreSpecialDialog = false;
        selected_index = -1;
      "
      @onSaved="submitFormSpecialClose($event)"
      :selected_item="selected_item"
      :store_id="$route.params.store_id"
    />
    <ConfirmDialogComp
      @onClosed="confirmDialog = false"
      @onSaved="deleteStoreSpecial($event)"
      :dialog="confirmDialog"
      message="Are you sure to permanent delete this store?"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import FormSpecialDinein from "@/components/back-office/DineIn/Store/FormSpecialDinein.vue";
import ConfirmDialogComp from "@/components/ConfirmDialog.vue";
export default {
  data: () => ({
    storeCloseData: {
      store_close: [],
    },
    search: "",
    detail_dialog: false,
    selected_item: {},
    selected_index: -1,
    dialog: false,
    change: 0,
    isLoadingData: false,
    edit_store_id: 0,
    edit_store_name: "",
    edit_time_name: "",
    edit_time_id: 0,
    testData: "",
    disable_popular: false,
    store_name_th: null,
    delete_id: "",
    pagination: {
      page_size: 100,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Date close",
        align: "center",
        value: "store_status",
        sortable: false,
      },
      {
        text: "Time close",
        align: "center",
        value: "store_province",
        sortable: false,
      },
      {
        text: "Note",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
    formStoreSpecialDialog: false,
    isDeleteSpecial: [],
    confirmDialog: false,
  }),
  components: { FormSpecialDinein, ConfirmDialogComp },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      productList: (state) => state.fetchDineIn.productListByStore,
    }),
    ...mapGetters(["isEditStoreApprove"]),
    pages() {
      if (this.dinein_store_list.length != 0) {
        this.pagination.totalItems = this.dinein_store_list.length;
      }
      if (
        this.pagination.page_size == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.page_size);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions({
      fetchStoreSpecialCloseList: "fetchDineIn/fetchStoreSpecialCloseList",
      changeStatusProductByID: "fetchDineIn/updateStatusProductByID",
      createStoreSpecialClose: "fetchDineIn/createStoreSpecialClose",
      updateStoreSpecialClose: "fetchDineIn/updateStoreSpecialClose",
      removeStoreSpecialClose: "fetchDineIn/removeStoreSpecialClose",
    }),
    moment,
    toEditStoreSpecial(item, index) {
      this.selected_item = item;
      this.selected_index = index;
      this.formStoreSpecialDialog = true;
    },
    toDeleteStoreSpecial(item, index) {
      this.selected_item = item;
      this.selected_index = index;
      this.confirmDialog = true;
    },
    async changeState(item) {
      let res = await this.changeStatusProductByID({
        status: item.product_status,
        productID: item.product_id,
      });
      if (res === false) {
        item.product_status != item.product_status;
      }
    },
    async fetchData() {
      this.isLoadingData = true;
      let result = await this.$store.dispatch(
        "fetchDineIn/fetchStoreSpecialCloseList",
        {
          store_id: this.$route.params.store_id,
        }
      );
      this.isLoadingData = false;
      if (result == false) return;
      this.storeCloseData = result;
    },
    async deleteStoreSpecial(e) {
      this.isDeleteSpecial.push(this.selected_item.id);
      let result = await this.removeStoreSpecialClose({
        store_id: this.$route.params.store_id,
        special_close_id: this.selected_item.id,
      });
      let index = this.isDeleteSpecial.findIndex(
        (val) => this.selected_item.id == val
      );
      this.isDeleteSpecial.splice(index, 1);
      this.confirmDialog = false;
      if (result == true) {
        let indexSpecial = this.storeCloseData.store_close.findIndex(
          (val) => val.id == this.selected_item.id
        );
        this.storeCloseData.store_close.splice(indexSpecial, 1);
      } else {
        alert("Can't delete package");
      }
    },
    submitFormSpecialClose(e) {
      console.log(this.selected_index);
      if (this.selected_index == -1) {
        this.createStoreSpecial(e);
      } else {
        console.log(111111);
        this.editStoreSpecial(e);
      }
    },
    async createStoreSpecial(e) {
      let result = await this.createStoreSpecialClose({
        store_id: e.form.store_id,
        dateTime: e.form.dateTime,
        startTime: e.form.startTime,
        endTime: e.form.endTime,
        description: e.form.description,
      });
      if (result == false) return;
      this.storeCloseData = result;
      await e.done();
      this.formStoreSpecialDialog = false;
      this.selected_index = -1;
    },
    async editStoreSpecial(e) {
      let result = await this.updateStoreSpecialClose({
        store_id: e.form.store_id,
        dateTime: e.form.dateTime,
        startTime: e.form.startTime,
        endTime: e.form.endTime,
        description: e.form.description,
        special_close_id: e.form.special_close_id,
      });
      if (result == false) return;
      this.storeCloseData = result;
      await e.done();
      this.formStoreSpecialDialog = false;
      this.selected_index = -1;
    },
  },
};
</script>

<style scoped>
.view-detail-btn {
  font-size: 13px;
  outline: none;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
